import { configureStore } from '@reduxjs/toolkit';

import channelReducer from './channel/channelSlice';
import uiReducer from './ui/uiSlice';
import imageModalReducer from './modal/imageModalSlice';
import overlayReducer from './overlay/overlaySlice';
import postReducer from './post/postSlice';
import preferencesReducer from './preferences/preferencesSlice';
import subredditReducer from './subreddit/subredditSlice';
import subscriptionReducer from './subscription/subscriptionSlice';
import userReducer from './user/userSlice';

export const store = configureStore({
  reducer: {
    channel: channelReducer,
    ui: uiReducer,
    imageModal: imageModalReducer,
    overlay: overlayReducer,
    post: postReducer,
    preferences: preferencesReducer,
    subreddit: subredditReducer,
    subscription: subscriptionReducer,
    user: userReducer,
  },
});
